import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCandy: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCandy"><Circle cx="12" cy="12" r="5.5" stroke="currentColor"/><Path d="M13.6562 6.5C14.1495 4.87182 14.9829 3.59687 16.3575 2.5L21.5004 7.64286C20.4035 9.01743 19.1286 9.85092 17.5005 10.3441" stroke="currentColor"/><Path d="M6.5 13.6558C4.87182 14.149 3.59687 14.9825 2.5 16.3571L7.64286 21.4999C9.01743 20.4031 9.85092 19.1281 10.3441 17.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconCandy;
